<template>
  <div class="colofon-social">
    <colofon-social-link href="http://app.nos.nl/op3/iran">
      <img
        class="social-img"
        src="../assets/img/copy.svg">
    </colofon-social-link>
    <colofon-social-icon
      :target="true"
      href="https://www.facebook.com/share.php?u=http://app.nos.nl/op3/iran">
      <img
        class="social-img"
        src="../assets/img/facebook.svg">
    </colofon-social-icon>
    <colofon-social-icon
      :target="true"
      href="https://twitter.com/intent/tweet?text=De nieuwe sancties tegen Iran hebben veel gevolgen voor Iraniërs. Stap in de schoenen van Yasmin (24) en ervaar de impact op haar leven. Correspondent Thomas Erdbrink geeft extra tekst en uitleg.&url=http://app.nos.nl/op3/iran">
      <img
        class="social-img"
        src="../assets/img/twitter.svg">
    </colofon-social-icon>
  </div>
</template>
<script>
import ColofonSocialLink from './ColofonSocialLink';
import ColofonSocialIcon from './ColofonSocialIcon';

export default {
  components: {
    ColofonSocialLink,
    ColofonSocialIcon,
  },
};
</script>
<style lang="scss" scoped>

  .colofon-social {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .social-img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/ColofonSocial.vue